import type { PathType } from './types';
import { getPath } from './types';

export const commonPaths: { [key: string]: PathType } = {
  applicationMenuDrawer: getPath('/application-menu', ['']),
  interactive: getPath('/interactive', ['sidebar.home', 'v2.interactive.index']),
  systemAdmin: getPath('/interactive/system-admin', [
    'sidebar.home',
    'v2.interactive.index',
    'v2.crm.systemAdmin.index'
  ]),

  employeeInfo: getPath('/employee-info', ['v2.employeeInfo.index']),

  // Auth related paths
  logout: getPath('/logout', []),
  signinOidc: getPath('/signin-oidc', []),
  signoutOidc: getPath('/signout-oidc', []),
  signoutCallbackOidc: getPath('/signout-callback-oidc', []),

  // Error pages
  serverError: getPath('/server-error', []),

  // V2 home
  home: getPath('/', ['v2.sidebar.home']),
  homeSub: getPath('/s', ['v2.sidebar.home'])
};
